/**
 * @generated SignedSource<<3fbe58d298bb7623ee7e8b99ec014d35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type PricingGuidancePriceRange = "HIGHER_RANGE" | "LOWER_RANGE" | "MEDIAN" | "NEAR_MEDIAN_HIGH" | "NEAR_MEDIAN_LOW" | "OUT_OF_RANGE_HIGH" | "OUT_OF_RANGE_LOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type pricingGuidanceTracking_item$data = {
  readonly pricingGuidance: {
    readonly priceRange: PricingGuidancePriceRange | null;
  } | null;
  readonly " $fragmentType": "pricingGuidanceTracking_item";
};
export type pricingGuidanceTracking_item$key = {
  readonly " $data"?: pricingGuidanceTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "pricingGuidanceTracking_item"
};

(node as any).hash = "3a35abb276b6a1b33f903438b0236d37";

export default node;
